module.exports = __webpack_public_path__ + "dd7982b4390886644a1d57d89ae94c60.jpg";